import { useTranslation } from "@/i18n/client";
import { DateInputProps } from "@mantine/dates";
import { InputTooltip } from "@/components/InputTooltip";
import DateInput from "@/components/DateInput";

export const HeatPumpDate = (props: DateInputProps) => {
  const { t } = useTranslation(["supplyPoint", "hints"]);

  return (
    <InputTooltip
      tooltipProps={{
        label: t("hints:supplyPoint.bundleServicesHeatPumpDate"),
      }}>
      <DateInput label={t("supplyPoint:heatPumpData.heatPumpDate")} clearable={true} {...props} />
    </InputTooltip>
  );
};
